import React from 'react';
import classNames from 'classnames';

import { PERSONALISED_MENTEE_EMAILERS_LINKS } from 'features/communicationManagement';
import FilterDrawer from './FilterDrawer';
import PersonalisedMenteeEmailersAddModal from './PersonalisedMenteeEmailersAddModal/PersonalisedMenteeEmailersAddModal';
import PersonalisedMenteeEmailersContent from './PersonalisedMenteeEmailersContent';
import PersonalisedMenteeEmailersHeaderActionables from './PersonalisedMenteeEmailersHeaderActionables';
import PersonalisedMenteeEmailersManageModal from './PersonalisedMenteeEmailersManageModal';
import SectionHeading from 'components/SectionHeading';
import styles from './PersonalisedMenteeEmailersPage.module.scss';

export default function PersonalisedMenteeEmailersPage() {
  return (
    <div className={styles.root}>
      <div className={styles.sectionHeader}>
        <SectionHeading title="Personalised Mentee Emailers" />
        <div className={classNames(styles.headerTitleAction, 'p-h-xxs')}>
          {PERSONALISED_MENTEE_EMAILERS_LINKS.map(
            ({ href, label, dividerRequired }) => {
              return (
                <div key={label}>
                  <a
                    href={href}
                    target="_blank"
                    className="link"
                    rel="noreferrer"
                  >
                    {label}
                  </a>
                  {dividerRequired && <span className="p-h-xxs">|</span>}
                </div>
              );
            }
          )}
          <PersonalisedMenteeEmailersHeaderActionables />
        </div>
      </div>
      <FilterDrawer />
      <PersonalisedMenteeEmailersContent />
      <PersonalisedMenteeEmailersManageModal />
      <PersonalisedMenteeEmailersAddModal />
    </div>
  );
}
